import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

export const fetchSingleVisual = async (id) => {
	try {
		const { data } = await ApiClient.GET('pomVisual', `${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const onAddPomVisual = async (body) => {
	try {
		const { data } = await ApiClient.POST('pomVisual', body, `add`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const onUpdatePomVisual = async (body, id) => {
	try {
		const { data } = await ApiClient.PUT('pomVisual', body, id);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const fetchPomSerialList = async () => {
	try {
		const { data } = await ApiClient.GET('pomSerialList');
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const onAddPom = async (body) => {
	try {
		const { data } = await ApiClient.POST('pomAction', body, 'add');
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const onUpdate = async (body, editId) => {
	try {
		const { data } = await ApiClient.PUT('pomAction', body, editId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const getAllPomResponse = async () => {
	try {
		const { data } = await ApiClient.GET('getAllPomResponse');
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchPomList = async (params = '') => {
	try {
		const { data } = await ApiClient.GET('pomAction', `all?${params}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const onDeletePom = async (id) => {
	try {
		const { data } = await ApiClient.DELETE('pomAction', {}, `${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const fetchPomInfo = async (id) => {
	try {
		const { data } = await ApiClient.GET('pomAction', id);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchMeasurementTemplateResponse = async (id) => {
	try {
		const { data } = await ApiClient.GET('getMeasurementTemplateResponse', `${id}?sort=serial`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onDuplicatePom = async (id, pomId) => {
	try {
		const { data } = await ApiClient.POST(
			'pomAction',
			{},
			`measurement-template/${id}/duplicate-library-pom/${pomId}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeLibraryPOMFromMeasurementTemplate = async (id, pomId) => {
	try {
		const { data } = await ApiClient.DELETE(
			'pomAction',
			{},
			`measurement-template/${id}/remove-pom/${pomId}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const loadLibraryPOMFromMainCategory = async (id, subCategoryId) => {
	try {
		const { data } = await ApiClient.POST(
			'pomAction',
			{},
			`measurement-template/${id}/load-from-main-category/subcategory/${subCategoryId}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const addLibraryPOMInMeasurementTemplate = async (templateId, ids) => {
	try {
		const { data } = await ApiClient.POST(
			'pomAction',
			{},
			`measurement-template/${templateId}?libraryPOMIds=${ids}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
